import { B as BigValueColorMode, a as BigValueGraphMode, b as BigValueJustifyMode, P as PercentChangeColorMode, c as BigValueTextMode } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  colorMode: BigValueColorMode.Value,
  graphMode: BigValueGraphMode.Area,
  justifyMode: BigValueJustifyMode.Auto,
  percentChangeColorMode: PercentChangeColorMode.Standard,
  showPercentChange: false,
  textMode: BigValueTextMode.Auto,
  wideLayout: true
};

export { defaultOptions, pluginVersion };
